import React from "react";
import { Route, Router } from "react-router-dom";
import App from "../containers/App";
import Callback from "./Callback";
import Auth from "./auth";
import history from "./history";

const auth = new Auth();

export default () => (
  <Router history={history} component={App}>
    <div>
      <Route path="/" render={props => <App auth={auth} {...props} />} />
      <Route
        path="/callback"
        render={props => {
          auth.handleAuthentication(props);
          return <Callback {...props} />;
        }}
      />
    </div>
  </Router>
);
